import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { endpoints } from "../../../services/apiurl";
import { Card } from "@mui/material";
import PageTitle from "../../UI/PageTitle";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InfinitySpin } from "react-loader-spinner";

const PrList = () => {
  let history = useHistory();
  let { restro_id } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);

  const columns = [
    {
      name: "Image",
      selector: (row) => (
        <img
          src={`${row.image}`}
          style={{ height: "150px", width: "150px", margin: "10px" }}
        ></img>
      ),
    },
    {
      name: "STATUS",

      selector: (row) => (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={row.id + "check1"}
            {...(row.status === 1 ? { checked: "checked" } : {})}
            onClick={() => sub(row.id, row.status)}
          />
          <label
            className="custom-control-label"
            style={{ marginBottom: "21px" }}
            for={row.id + "check1"}
          ></label>
        </div>
      ),
    },
  ];

  const sub = async (id, oldStatus) => {
    const newStatus = oldStatus === 1 ? 0 : 1;

    try {
      const response = await axios.post(endpoints.pr_status, {
        id,
        status: newStatus,
      });

      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );

      // Show toaster notification
      const message = newStatus === 1 ? "Activated" : "Deactivated";
      toast.success(`Status ${message} successfully!`, { autoClose: 2000 });
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status. Please try again later.");
    }
  };

  const fetchData = async (page, per_page) => {
    var id = "";
    await axios
      .post(endpoints.get_pr, {
        page,
        per_page,
        id,
      })
      .then(
        (response) => {
          setIsLoaded(true);
          setItems(response.data.data);
          // console.log(response.data.data)
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const handlePageChange = (page) => {
    fetchData(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="spinner">
        <InfinitySpin
          visible={true}
          width="200"
          color="#fbaa1a"
          ariaLabel="infinity-spin-loading"
        />
      </div>
    );
  } else {
    return (
      <div className="App">
        <PageTitle
          title="Press Release List"
          linkurl="/dashboard/addprimg"
          linkTitle="Add Image"
        />

        <Card className="px-3 py-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default PrList;
